module.exports = __webpack_public_path__ + "static/img/ai_data.1144570c.jpg";